import { GENERAL_USER_REDUCER, CHANGE_TOKEN_STATE, CHANGE_CLIENT, RESET_USER_DATA, } from "./types";
const initialState = {
    token: null,
    userData: null,
    client: {
        advisors: [],
    },
    advisor: {
        clients: [],
        selectedClient: 0,
    },
    accounts: [],
    register_success: false,
    session_expired: false,
    viaEmail: null,
    userAdvisorId: null,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GENERAL_USER_REDUCER:
            return {
                ...state,
                ...action.payload,
            };
        case CHANGE_TOKEN_STATE:
            return {
                ...state,
                token: action.payload.token,
            };
        case CHANGE_CLIENT:
            return {
                ...state,
                advisor: {
                    ...state.advisor,
                    selectedClient: action.payload,
                },
            };
        case RESET_USER_DATA:
            return {
                ...initialState,
                client: {
                    ...initialState.client,
                    advisors: [],
                },
                advisor: {
                    ...initialState.advisor,
                    clients: [],
                },
                accounts: [],
            };
        default:
            return state;
    }
};
